import { Position } from './Position';

export class ChartContext {
    public readonly ctx: CanvasRenderingContext2D;
    public readonly canvas: HTMLCanvasElement;
    public readonly centerPosition: Position;
    public readonly maxRadius: number;
    public readonly fontSize: number;
    public readonly margin: number;

    constructor(
        ctx: CanvasRenderingContext2D,
        canvas: HTMLCanvasElement,
        centerPosition: Position,
        maxRadius: number,
        fontSize: number = 20,
        margin: number = 20
    ) {
        this.ctx = ctx;
        this.centerPosition = centerPosition;
        this.maxRadius = maxRadius;
        this.canvas = canvas;
        this.fontSize = fontSize;
        this.margin = margin;
    }

    public rightEdgeX(): number { return this.centerPosition.x + this.maxRadius;  }
    public leftEdgeY(): number { return this.centerPosition.x - this.maxRadius;  }

} 